export const CREATE_BASKET = 'dashboard/basket/CREATE_BASKET';
export const CREATE_BASKET_SUCCESS = 'dashboard/basket/CREATE_BASKET_SUCCESS';

export const GET_BASKET = 'dashboard/basket/GET_BASKET';
export const GET_BASKET_SUCCESS = 'dashboard/basket/GET_BASKET_SUCCESS';

export const CHECK_BASKET = 'dashboard/basket/CHECK_BASKET';
export const CHECK_BASKET_COMPLETE = 'dashboard/basket/CHECK_BASKET_COMPLETE';

export const ADD_TO_BASKET_FAILED = 'dashboard/basket/ADD_TO_BASKET_FAILED';

export const ADD_ACCOMMODATION_TO_BASKET =
  'dashboard/basket/ADD_ACCOMMODATION_TO_BASKET';
export const ADD_ACCOMMODATION_TO_BASKET_SUCCESS =
  'dashboard/basket/ADD_ACCOMMODATION_TO_BASKET_SUCCESS';

export const ADD_ACCOMMODATION_EXTRAS_TO_BASKET =
  'dashboard/basket/ADD_ACCOMMODATION_EXTRAS_TO_BASKET';
export const ADD_ACCOMMODATION_EXTRAS_TO_BASKET_SUCCESS =
  'dashboard/basket/ADD_ACCOMMODATION_EXTRAS_TO_BASKET_SUCCESS';

export const ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET =
  'dashboard/basket/ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET';
export const ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET_SUCCESS =
  'dashboard/basket/ADD_ACCOMMODATION_AND_EXTRAS_TO_BASKET_SUCCESS ';

export const ADD_TRANSPORT_TO_BASKET =
  'dashboard/basket/ADD_TRANSPORT_TO_BASKET';
export const REMOVE_TRANSPORT = 'dashboard/basket/REMOVE_TRANSPORT';
export const REMOVE_TRANSPORT_SUCCESS =
  'dashboard/basket/REMOVE_TRANSPORT_SUCCESS';

export const ADD_EXTRAS_TO_BASKET = 'dashboard/basket/ADD_EXTRAS_TO_BASKET';

export const ADD_TICKETS_TO_BASKET = 'dashboard/basket/ADD_TICKETS_TO_BASKET';

export const ADD_NAME_CHANGE_TO_BASKET =
  'dashboard/basket/ADD_NAME_CHANGE_TO_BASKET';

export const RESET_BASKET = 'dashboard/basket/RESET_BASKET';
export const RESET_BASKET_SUCCESS = 'dashboard/basket/RESET_BASKET_SUCCESS';

export const REMOVE_ACCOMMODATION = 'dashboard/basket/REMOVE_ACCOMMODATION';

export const REMOVE_EXTRA = 'dashboard/basket/REMOVE_EXTRA';
export const REMOVE_EXTRA_SUCCESS = 'dashboard/basket/REMOVE_EXTRA_SUCCESS';

export const REMOVE_ITEMS = 'dashboard/basket/REMOVE_ITEMS';
export const PROCESSING_RESPONSE = 'dashboard/basket/PROCESSING_RESPONSE';
